// extracted by mini-css-extract-plugin
export var isWaving = "about-module--is-waving--STWiE";
export var waveAnimation = "about-module--wave-animation--83Kzc";
export var waveEmoji = "about-module--wave-emoji--mZLEu";